import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import {
  FormRadio,
  FormInputtextarea,
} from "../../../../../components/formElement";
import { option_treatment_type } from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleTreatmentStep2(props) {
  const { setActiveIndex, onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    a1: null,
    a2: "",
    a3: "",
  };
  const { handleSubmit, getValues, reset, yup, setSchema, setting } =
    useHookForm({
      defaultValues,
    });
  const tbData = [
    {
      key: 1,
      type: (
        <div className="font-bold">
          近視控制
          <br />
          治療選擇
        </div>
      ),
      liquid: <span className="font-bold">阿托品藥水</span>,
      daily: <span className="font-bold">學童近視控制專用日拋</span>,
      shaping: <span className="font-bold">角膜塑型片</span>,
      glass: <span className="font-bold">近視控制框架鏡片</span>,
    },
    {
      key: 2,
      type: <span className="font-bold">使用方式</span>,
      liquid: <>睡前點藥</>,
      daily: (
        <>
          ☼ 日間配戴約<span className="font-bold">10-15</span>小時，
          <span className="font-bold">一週至少6天</span>
        </>
      ),
      shaping: (
        <>
          ☪夜間配戴<span className="font-bold">6-8</span>小時，
          <span className="font-bold">不超過10小時</span>
        </>
      ),
      glass: <>☼ 日間全時間配戴</>,
    },
    {
      key: 3,
      type: (
        <>
          <span className="font-bold">度數/眼軸</span>與沒有使用者比較
        </>
      ),
      liquid: (
        <>
          <span className="font-bold border-bottom-1">
            可降低近視進展風險60%
          </span>
          <br />
          <div>度數：不同濃度(0.01%~0.5%)效果：每年增加約30-40度</div>
          <div>眼軸：不同濃度(0.01%~0.5%):-0.15mm (每年)</div>
        </>
      ),
      daily: (
        <>
          <span className="font-bold border-bottom-1">
            可降低近視進展風險52%-59%
          </span>
          <br />
          <div>度數：相對於對照組兩年延緩54度的度數增加。</div>
          <div>眼軸：相對於對照組兩年延緩0.24mm的眼軸增加。</div>
        </>
      ),
      shaping: (
        <>
          <span className="font-bold border-bottom-1">
            可降低近視進展風險35%至55%
          </span>
          <br />
          <div>眼軸：兩年延緩增加0.28 mm</div>
        </>
      ),
      glass: (
        <>
          <span className="font-bold border-bottom-1">
            可降低近視進展風險52%-62%
          </span>
          <br />
          <div>度數：相對於對照組兩年延緩44度的度數增加。</div>
          <div>眼軸：相對於對照組兩年延緩0.34mm的眼軸增加。</div>
        </>
      ),
    },
    {
      key: 4,
      type: <span className="font-bold">☺ 優點</span>,
      liquid: (
        <>
          <div className="font-bold">健保給付0.01%(限12歲以下)</div>
          <div>健保給付0.125%以上阿托品眼藥</div>
          <div className="font-bold">(0.05%阿托品目前健保不給付。)</div>
        </>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>每日拋棄；安全方便</li>
          <li>無須搓洗；出遊不用帶藥水</li>
          <li>運動安全；戶外活動意願高</li>
          <li>視力穩定；全天保持清晰</li>
          <li>異物感低，單日遺失費用低</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>白天不須戴眼鏡</li>
          <li>運動安全；戶外活動意願更高</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>無侵入性；不接觸眼睛</li>
          <li>可選擇眼鏡造型</li>
        </ul>
      ),
    },
    {
      key: 5,
      type: <span className="font-bold">☹ 缺點</span>,
      liquid: (
        <ul className="pl-4 m-0">
          <li>搭配眼鏡、隱形眼鏡才能看清楚</li>
          <li>若隨意停藥；度數會增加較快</li>
          <li>高濃度會畏光；看近時不清楚</li>
        </ul>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>白天至少要配戴10小時以上</li>
          <li>取下隱形眼鏡後，須搭配眼鏡矯正，一周須戴6天</li>
          <li>度數超過650度與散光超過75度不合適</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>需家長監督清潔鏡片</li>
          <li>晚上至少要睡眠6小時以上</li>
          <li>晚上視力不穩定</li>
          <li>異物感較重</li>
          <li>有破損、遺失風險及費用</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>運動時需注意安全</li>
          <li>需要孩童配戴意願高</li>
          <li>配戴時間少影響效果</li>
          <li>外觀可能受影響</li>
        </ul>
      ),
    },
    {
      key: 6,
      type: <span className="font-bold">適合族群</span>,
      liquid: (
        <ul className="pl-4 -0">
          <li>經濟考量</li>
          <li>無法全時間負責鏡片照顧</li>
        </ul>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>忙碌的家長</li>
          <li>不想清潔鏡片</li>
          <li>重視睡眠品質、發育</li>
          <li>睡眠較少的國高中生</li>
          <li>喜愛運動、戶外活動</li>
          <li>在意外表的孩童</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>喜愛運動、戶外活動</li>
          <li>白天不想戴眼鏡、隱形眼鏡</li>
          <li>睡眠時間充足</li>
          <li>能夠定期回診</li>
          <li>在意外表的孩童</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>不想接觸眼睛</li>
          <li>喜歡配戴眼鏡</li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    setSchema(
      yup
        .object({
          a1: yup.number().required("必填").nullable(),
          a2: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.a1 !== 10 || value;
              }
            ),
          a3: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step2) {
      reset(redux_form.formDetail.step2);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step2: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 2 });
  };

  return (
    <>
      <div className="flex align-items-center mb-2">
        <span className="text-2xl font-bold">選項比較</span>
        <span className="text-xl ml-3">
          當兒童青少年近視時，您可以選擇的近視控度選項分析如下：
        </span>
        <span className="flex-auto"></span>
        <span
          className="hover:text-gray-600 border-bottom-1 cursor-pointer"
          onClick={() => setActiveIndex(6)}
        >
          參考文獻
        </span>
      </div>
      <div className="overflow-x-auto">
        <table
          className="md:w-full table-layout-fixed table-collapse"
          style={{ width: "60rem" }}
        >
          <tbody>
            {tbData.map((item, index) => (
              <tr
                key={item.key}
                className="word-break"
                style={{
                  backgroundColor:
                    index === 0
                      ? "#ff9966"
                      : index % 2 === 1
                      ? "#fbe5d6"
                      : "#d8e9cd",
                }}
              >
                <td className="w-8rem border-1 border-500 p-1">{item.type}</td>
                <td className="border-1 border-500 p-1">{item.liquid}</td>
                <td className="border-1 border-500 p-1">{item.daily}</td>
                <td className="border-1 border-500 p-1">{item.shaping}</td>
                <td className="border-1 border-500 p-1">{item.glass}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="text-lg mt-4">
        <div className="flex align-items-center text-2xl font-bold mb-1">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          您目前比較想要選擇的方式是? (單選)
        </div>
        <div className="flex flex-column ml-2">
          {option_treatment_type.map((item) => (
            <FormRadio
              key={`treatment_type_${item.value}`}
              setting={setting}
              data={{
                name: "a1",
                label: item.label,
                value: item.value,
              }}
            />
          ))}
        </div>
        {getValues("a1") === 10 && (
          <FormInputtextarea
            className="w-full md:w-8"
            setting={setting}
            data={{
              name: "a2",
            }}
          />
        )}

        <div className="text-2xl font-bold mt-3 mb-1">
          對於以上治療方式，我想要再瞭解更多，我的問題有：
        </div>
        <FormInputtextarea
          className="w-full md:w-8"
          setting={setting}
          data={{
            name: "a3",
            placeholder: "若無請填寫『無』",
          }}
        />

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：前言"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 0 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="下一步：考量"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
